//Publicas
import {HomePage} from './HomePage'
import {LoginPage} from './LoginPage'
import {RegisterPage} from './RegisterPage'

//Privadas
import {InicioPage} from './InicioPage'
import {MetabasePage} from './MetabasePage'
import { NuevaONGPage } from './NuevaONGPage'
import ContactosONGPage from './ContactosONGPage'
import { TramitacionesPage } from './TramitacionesPage'
import { InformesPage } from './InformesPage'
import { TableroPage } from './TableroPage'
import { TablerosAdminPage } from './TablerosAdminPage'
import { ApiKeysPage } from './ApiKeysPage'
import MapasPage from './MapasPage'
import VersionHistoryPage from './VersionHistoryPage'
import RecuperarObrasPage from './RecuperarObrasPage'
import BaseMatrizPage from './BaseMatrizPage'
import CalendarioPage from './CalendarioPage'
import AnalisisPagosPage from './AnalisisPagosPage'
import ObrasSinPagosPage from './ObrasSinPagosPage'
import { GestionNotificacionesPage } from './GestionNotificacionesPage'
import ChatHistorialPage from './ChatHistorialPage'
import InformeGestionPage from './InformeGestionPage'
import InformeOrganizacionesPage from './InformeOrganizacionesPage'
import IntervencionClubesDeportivosPage from './IntervencionClubesDeportivosPage'
import DashboardMonitoreoPage from './DashboardMonitoreoPage'
import CicloDeVidaPage from './CicloDeVidaPage'
import CicloDeVidaV2Page from './CicloDeVidaV2Page'
import CircuitoContactosPage from './CircuitoContactosPage'
import GestionUsuariosPage from './GestionUsuariosPage'
import AlertasMejoramientosPage from './AlertasMejoramientosPage'
import AlertasObrasPage from './AlertasObrasPage'
import SeguimientoEventosPage from './SeguimientoEventosPage'

export{
    //paginas publicas
    HomePage,
    LoginPage,
    RegisterPage,
    //paginas privadas
    InicioPage,
    MetabasePage,
    NuevaONGPage,
    ContactosONGPage,
    TramitacionesPage,
    InformesPage,
    TableroPage,
    TablerosAdminPage,
    MapasPage,
    ApiKeysPage,
    VersionHistoryPage,
    RecuperarObrasPage,
    BaseMatrizPage,
    CalendarioPage,
    AnalisisPagosPage,
    ObrasSinPagosPage,
    GestionNotificacionesPage,
    ChatHistorialPage,
    InformeGestionPage,
    InformeOrganizacionesPage,
    IntervencionClubesDeportivosPage,
    DashboardMonitoreoPage,
    CicloDeVidaPage,
    CicloDeVidaV2Page,
    CircuitoContactosPage,
    GestionUsuariosPage,
    AlertasMejoramientosPage,
    AlertasObrasPage,
    SeguimientoEventosPage
}